"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var noop = function (val) { return val; };
var convertToNumber = function (val) { return +val; };
var convertToBool = function (val) { return val === 'Y'; };
var createNull = function () { return null; };
var createFalse = function () { return false; };
var createEmptyArray = function () { return []; };
var defaultEventDataKeyMap = {
    'p.pr': {
        name: 'parentalRating',
        typeConverter: convertToNumber,
        createDefault: createNull,
    },
    'p.dur': {
        name: 'eventDuration',
        typeConverter: convertToNumber,
        createDefault: createNull,
    },
    'p.id': {
        name: 'presentEventID',
        typeConverter: noop,
        createDefault: createNull,
    },
    'p.st': {
        name: 'startTime',
        typeConverter: convertToNumber,
        createDefault: createNull,
    },
    'p.rst': {
        name: 'isRestartable',
        typeConverter: convertToBool,
        createDefault: createFalse,
    },
    'f.id': {
        name: 'followingEventID',
        typeConverter: noop,
        createDefault: createNull,
    },
    s: {
        name: 'subtitleTracks',
        typeConverter: noop,
        createDefault: createEmptyArray,
    },
    a: {
        name: 'audioTracks',
        typeConverter: noop,
        createDefault: createEmptyArray,
    },
};
var splitEventDataProps = function (delimeter) { return function (part) {
    var _a = part.split(delimeter), name = _a[0], value = _a[1];
    return { name: name, value: value };
}; };
var reduceEventData = function (eventDataKeyMap) { return function (result, _a) {
    var name = _a.name, value = _a.value;
    if (value === '' || value === undefined) {
        return result;
    }
    var subAudioMatch = name.match(/^p\.([sa])(\d+)\.id$/);
    if (subAudioMatch) {
        var subAudioOb = eventDataKeyMap[subAudioMatch[1]];
        result[subAudioOb.name].push({
            lang: subAudioOb.typeConverter(value),
            position: +subAudioMatch[2],
        });
    }
    else {
        var eventDataMapping = eventDataKeyMap[name];
        if (eventDataMapping) {
            result[eventDataMapping.name] = eventDataMapping.typeConverter(value);
        }
    }
    return result;
}; };
var cleanUp = function (xml) {
    var xmlStart = xml.indexOf('<?xml ');
    return xml.substring(xmlStart).trim();
};
var parse = function (xml, parser) {
    xml = cleanUp(xml);
    return parser.parseFromString(xml, 'text/xml');
};
exports.parseID3Data = function (id3data, parser) {
    if (id3data === void 0) { id3data = ''; }
    var parsedData = parse(id3data, parser);
    if (!parsedData) {
        return null;
    }
    var paragraphNodes = parsedData.getElementsByTagName('p');
    var latestNode = Array.from(paragraphNodes).pop();
    if (latestNode) {
        return latestNode.firstElementChild.textContent;
    }
    else {
        return null;
    }
};
exports.parseEventDataString = function (eventData, eventDataKeyMap) {
    if (eventData === void 0) { eventData = ''; }
    if (eventDataKeyMap === void 0) { eventDataKeyMap = defaultEventDataKeyMap; }
    var initialisedResultObject = Object.keys(eventDataKeyMap).reduce(function (prev, nextKey) {
        prev[eventDataKeyMap[nextKey].name] = eventDataKeyMap[nextKey].createDefault();
        return prev;
    }, {});
    var result = eventData
        .split(',')
        .map(function (s) { return s.trim(); })
        .map(splitEventDataProps('='))
        .reduce(reduceEventData(eventDataKeyMap), initialisedResultObject);
    var langSort = function (a, b) { return (a.position < b.position ? -1 : a.position > b.position ? 1 : 0); };
    result.subtitleTracks.sort(langSort);
    result.audioTracks.sort(langSort);
    return result;
};
exports.createBoundaryEventFromID3 = function (id3MetaData, parser) {
    var toParsedBoundaryData = function (eventData) {
        if (eventData) {
            return exports.parseEventDataString(eventData);
        }
        return null;
    };
    var validateBoundaryData = function (currentEventData) {
        var presentEventID = currentEventData.presentEventID;
        return typeof presentEventID === 'string' && presentEventID.length > 0;
    };
    var currentEvent = toParsedBoundaryData(exports.parseID3Data(id3MetaData, parser));
    if (currentEvent && validateBoundaryData(currentEvent)) {
        return {
            isEventBoundary: null,
            isFirstEvent: null,
            currentEventData: currentEvent,
        };
    }
    else {
        return null;
    }
};
